/* eslint-disable no-nested-ternary */
/* eslint-disable function-paren-newline */
// Assets
import cross from '../../static/images/remove.png';

// Libraries
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

// Components
import { Overlay } from '..';

// Styles
import './popup.scss';

const Portal = ({ children }) =>
    createPortal(children, document.getElementById('modal-root'));

const Popup = props => {
    const {
        title,
        showCloseIcon,
        showOverlay,
        showFilter,
        closePopup,
        children,
        type,
    } = props;
    const childrenWithProps = React.Children.map(children, child =>
        cloneElement(child, { ...props })
    );
    return (
        <Portal>
            {showFilter ? (
                <div className="popup-wrap">
                    {showOverlay ? <Overlay closeFilter={closePopup} /> : null}
                    <div
                        className={`popup ${
                            type === 'LARGE'
                                ? 'large-popup'
                                : type === 'MEDIUM'
                                    ? 'md-popup'
                                    : ''
                        }`}
                    >
                        <div className="sidebarHead">
                            <h2>{title}</h2>
                            <span className="crossIcon" onClick={closePopup}>
                                <img
                                    src={showCloseIcon ? cross : null}
                                    alt="Close Icon"
                                />
                            </span>
                        </div>
                        <div className="sidebarContent">
                            {childrenWithProps}
                        </div>
                    </div>
                </div>
            ) : null}
        </Portal>
    );
};

Popup.propTypes = {
    children: PropTypes.node,
    closePopup: PropTypes.func,
    showCloseIcon: PropTypes.bool,
    showFilter: PropTypes.bool,
    showOverlay: PropTypes.bool,
    title: PropTypes.string,
    type: PropTypes.string,
};

export default Popup;
